// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 21 hooks for backend/shifts.

import { useBackend } from '../useBackend'

/** POST /api/shifts/applyCorrection */
export function useApplyCorrection<T = any>() {
  return useBackend<T>('shifts/applyCorrection')
}

/** POST /api/shifts/batchApplyCorrections */
export function useBatchApplyCorrections<T = any>() {
  return useBackend<T>('shifts/batchApplyCorrections')
}

/** POST /api/shifts/batchCloseCorrections */
export function useBatchCloseCorrections<T = any>() {
  return useBackend<T>('shifts/batchCloseCorrections')
}

/** POST /api/shifts/closeCorrection */
export function useCloseCorrection<T = any>() {
  return useBackend<T>('shifts/closeCorrection')
}

/** POST /api/shifts/fixShiftDates */
export function useFixShiftDates<T = any>() {
  return useBackend<T>('shifts/fixShiftDates')
}

/** POST /api/shifts/getDuplicateSlots */
export function useGetDuplicateSlots<T = any>() {
  return useBackend<T>('shifts/getDuplicateSlots')
}

/** POST /api/shifts/getKmDiscrepancies */
export function useGetKmDiscrepancies<T = any>() {
  return useBackend<T>('shifts/getKmDiscrepancies')
}

/** POST /api/shifts/getPendingCorrections */
export function useGetPendingCorrections<T = any>() {
  return useBackend<T>('shifts/getPendingCorrections')
}

/** POST /api/shifts/getReconcileProposals */
export function useGetReconcileProposals<T = any>() {
  return useBackend<T>('shifts/getReconcileProposals')
}

/** POST /api/shifts/getShiftDrafts */
export function useGetShiftDrafts<T = any>() {
  return useBackend<T>('shifts/getShiftDrafts')
}

/** POST /api/shifts/getUberReportCoverage */
export function useGetUberReportCoverage<T = any>() {
  return useBackend<T>('shifts/getUberReportCoverage')
}

/** POST /api/shifts/getUncertainShifts */
export function useGetUncertainShifts<T = any>() {
  return useBackend<T>('shifts/getUncertainShifts')
}

/** POST /api/shifts/getVehicleMismatches */
export function useGetVehicleMismatches<T = any>() {
  return useBackend<T>('shifts/getVehicleMismatches')
}

/** POST /api/shifts/getVehicleSlotClashes */
export function useGetVehicleSlotClashes<T = any>() {
  return useBackend<T>('shifts/getVehicleSlotClashes')
}

/** POST /api/shifts/markKmSeen */
export function useMarkKmSeen<T = any>() {
  return useBackend<T>('shifts/markKmSeen')
}

/** POST /api/shifts/notifyDriverKm */
export function useNotifyDriverKm<T = any>() {
  return useBackend<T>('shifts/notifyDriverKm')
}

/** POST /api/shifts/previewCorrectionBatch */
export function usePreviewCorrectionBatch<T = any>() {
  return useBackend<T>('shifts/previewCorrectionBatch')
}

/** POST /api/shifts/proposeCorrection */
export function useProposeCorrection<T = any>() {
  return useBackend<T>('shifts/proposeCorrection')
}

/** POST /api/shifts/reconcileShift */
export function useReconcileShift<T = any>() {
  return useBackend<T>('shifts/reconcileShift')
}

/** POST /api/shifts/rejectCorrection */
export function useRejectCorrection<T = any>() {
  return useBackend<T>('shifts/rejectCorrection')
}

/** POST /api/shifts/releaseShiftDraft */
export function useReleaseShiftDraft<T = any>() {
  return useBackend<T>('shifts/releaseShiftDraft')
}
